import App from '~/scripts/App'
import setScrollbarWidth from '~/scripts/tailwindcss/plugins/set-scrollbar-width'
import '~/styles/main.css'

document.addEventListener('DOMContentLoaded', async () => {
  await document.fonts.ready
  App()

  if (document.querySelector('media-player')) {
    import('vidstack/player')
    import('vidstack/player/layouts')
    import('vidstack/player/ui')
  }
})

const scrollbarWidthEvents = ['load', 'resize']
for (const event of scrollbarWidthEvents) {
  window.addEventListener(event, () => {
    setScrollbarWidth()
  })
}
setScrollbarWidth()
